import React from 'react'
import styles from './styles.css'

export default function GenericTextInstructions(title, instructions) {
  return (
    <div className={`col-md-10 ${styles.container}`}>
      <h2 className="tds-orionx-font-dm__h5">{title}</h2>
      <div className={styles.justifiedFlex}>
        <p className="tds-orionx-font-dm__body">{instructions}</p>
      </div>
    </div>
  )
}
